import React, { useEffect, useMemo, useState } from 'react';
import PT from 'prop-types';
import { matchRoutes, useLocation } from 'react-router-dom';
import findIndex from 'lodash/findIndex';
import { styled } from 'components';
import {
  ApprovedApplicants,
  data as applicantsDashboardData,
  NewApplicants,
  NextStepsApplicants,
  RejectedApplicants,
  StarredApplicants,
  TabsToolbar,
} from 'components/ApplicantsDashboard';
import styles from 'styles/ApplicantsDashboard';
import { getProfileId } from '../../utils';

const StyledRoot = styled('div')(styles);

const {
  NEXT_STEPS_PATH,
  APPLICANTS_PATH,
  APPROVED_PATH,
  REJECTED_PATH,
  STARRED_PATH,
  LIST_LAYOUT,
  TABS,
} = applicantsDashboardData;

const ApplicantsDashboard = (props) => {
  const { jobId, job } = props;
  const location = useLocation();
  const profileId = getProfileId();
  const profileIdsToHideInfo = (
    process.env.HIDE_JOB_BUTTONS_BY_PROFILE_ID || ''
  )
    .split('|')
    .map(Number);
  const hideByProfile = profileIdsToHideInfo.includes(
    Number(profileId),
  );

  const matches = useMemo(
    () =>
      matchRoutes(
        TABS.map((o) => ({ path: o.path })),
        location.pathname,
      ),
    [location.pathname],
  );
  const matchedRoutePath = matches?.[0]?.route?.path;

  const { webUrl } = job || {};

  const [curTab, setCurTab] = useState(0);
  const [layout, setLayout] = useState(LIST_LAYOUT);

  useEffect(() => {
    const index = findIndex(TABS, ['path', matchedRoutePath]);
    if (index !== -1 && matchedRoutePath !== TABS[curTab].path) {
      setCurTab(index);
    }
  }, [matchedRoutePath]);

  const renderList = () => {
    const commonProps = {
      jobId,
      webUrl: webUrl || '',
      layoutType: layout,
    };

    switch (matchedRoutePath) {
      case APPLICANTS_PATH: {
        return <NewApplicants {...commonProps} />;
      }
      case APPROVED_PATH: {
        return <ApprovedApplicants {...commonProps} />;
      }
      case REJECTED_PATH: {
        return <RejectedApplicants {...commonProps} />;
      }
      case STARRED_PATH: {
        return hideByProfile ? null : (
          <StarredApplicants {...commonProps} />
        );
      }
      case NEXT_STEPS_PATH: {
        return hideByProfile ? null : (
          <NextStepsApplicants {...commonProps} />
        );
      }
      default:
        return null;
    }
  };

  return (
    <StyledRoot className="container">
      <div className="toolbarContainer">
        <TabsToolbar
          jobId={jobId}
          layoutType={layout}
          tab={curTab}
          setTab={setCurTab}
          setLayout={setLayout}
          webUrl={webUrl || ''}
        />
      </div>
      {renderList()}
    </StyledRoot>
  );
};

ApplicantsDashboard.propTypes = {
  jobId: PT.number.isRequired,
  job: PT.shape({
    webUrl: PT.string,
  }).isRequired,
};

export default ApplicantsDashboard;
